module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('router-view', {
    staticClass: "Router"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-9ed2f468"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 149
// module chunks = 19